import React from 'react';
import t from 'shared/utils/translation';
// eslint-disable-next-line no-restricted-imports
import {
  BodyText,
  PageHeader,
  Link,
} from '@grnhse/seedling/lib/azalea/typography';
import { Bonsai, BonsaiConfiguration } from '@grnhse/bonsai/lib/core';
import { standardRequestWithErrorFlash } from 'shared/utils/request';
import styled from 'styled-components';
// eslint-disable-next-line max-len
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/loading_spinner'. 'node_modules/@grnhse/seedling/lib/azalea/components/loading_spinner.js' implicitly has an 'any' type.
// eslint-disable-next-line no-restricted-imports
import LoadingSpinner from '@grnhse/seedling/lib/azalea/components/loading_spinner';
import { SecondaryButtonLink } from '@grnhse/seedling/lib/birch/components/buttons';
import {
  MainHeader as BonsaiMainHeader,
  Body as BonsaiBody,
  Link as BonsaiLink,
} from '@grnhse/bonsai/lib/components/typography';
// eslint-disable-next-line max-len
import { SecondaryButtonLink as BonsaiSecondaryButtonLink } from '@grnhse/bonsai/lib/components/buttons/secondary-button';
import { LoadingSpinner as BonsaiLoadingSpinner } from '@grnhse/bonsai/lib/components/loading-spinner';
import Logo from '../components/logo';

const PageTitle = function ({ bonsaiEnabled }: { bonsaiEnabled: boolean }) {
  if (bonsaiEnabled) {
    return (
      <BonsaiMainHeader>
        {t('self_schedule.candidate_view.interview_scheduled')}
      </BonsaiMainHeader>
    );
  }

  return (
    <PageHeader>
      {t('self_schedule.candidate_view.interview_scheduled')}
    </PageHeader>
  );
};

const ConfirmationBody = function ({
  submitting,
  bonsaiEnabled,
}: {
  submitting: boolean;
  bonsaiEnabled: boolean;
}) {
  if (bonsaiEnabled) {
    return (
      <BonsaiBody>
        {submitting && (
          <SubmitSpinner>
            <BonsaiLoadingSpinner size={'large'} />
          </SubmitSpinner>
        )}
        {t('self_schedule.candidate_view.email_confirmation')}
      </BonsaiBody>
    );
  }

  return (
    <BodyText>
      {submitting && (
        <SubmitSpinner>
          <LoadingSpinner size={'large'} />
        </SubmitSpinner>
      )}
      {t('self_schedule.candidate_view.email_confirmation')}
    </BodyText>
  );
};

const ResendLink = function ({
  bonsaiEnabled,
  onClick,
}: {
  bonsaiEnabled: boolean;
  onClick: (event: React.SyntheticEvent<HTMLAnchorElement>) => boolean;
}) {
  if (bonsaiEnabled) {
    return (
      <BonsaiLink onClick={onClick} href="#">
        {t('self_schedule.candidate_view.resend_email')}
      </BonsaiLink>
    );
  }
  return (
    <Link style={{ cursor: 'pointer' }} href="#" onClick={onClick}>
      {t('self_schedule.candidate_view.resend_email')}
    </Link>
  );
};

const RescheduleButton = function ({
  bonsaiEnabled,
  rescheduleUrl,
}: {
  bonsaiEnabled: boolean;
  rescheduleUrl: string;
}) {
  const label = t('self_schedule.candidate_view.reschedule_interview');
  if (bonsaiEnabled) {
    return (
      <div style={{ marginTop: '32px' }}>
        <BonsaiSecondaryButtonLink href={rescheduleUrl} ariaLabel={label}>
          {label}
        </BonsaiSecondaryButtonLink>
      </div>
    );
  }
  return (
    <div style={{ marginTop: '48px' }}>
      <SecondaryButtonLink href={rescheduleUrl}>
        {t('self_schedule.candidate_view.reschedule_interview')}
      </SecondaryButtonLink>
    </div>
  );
};

type Props = {
  resendConfirmationUrl: string;
  rescheduleUrl: string;
  isReschedulable: boolean;
  bonsaiEnabled: boolean;
  bonsaiProps: BonsaiConfiguration;
  logoUrl: string | null;
};

type State = {
  submitting: boolean;
};

export default class InterviewConfirmation extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      submitting: false,
    };
  }

  resendConfirmation = (event: React.SyntheticEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    this.setState({ submitting: true });

    standardRequestWithErrorFlash
      .post(this.props.resendConfirmationUrl)
      .catch(() => {
        this.setState({ submitting: false });
      })
      .then(() => {
        this.setState({ submitting: false });
      });

    return false;
  };

  render() {
    const { submitting } = this.state;
    const {
      rescheduleUrl,
      isReschedulable,
      bonsaiEnabled,
      bonsaiProps,
      logoUrl,
    } = this.props;

    return (
      <Bonsai configuration={bonsaiProps || {}}>
        <Wrapper>
          {bonsaiEnabled && logoUrl && <Logo logoUrl={logoUrl} />}
          <PageTitle bonsaiEnabled={bonsaiEnabled} />
          <ConfirmationBody
            submitting={submitting}
            bonsaiEnabled={bonsaiEnabled}
          />
          <ResendLink
            bonsaiEnabled={bonsaiEnabled}
            onClick={this.resendConfirmation}
          />
          {isReschedulable && (
            <RescheduleButton
              bonsaiEnabled={bonsaiEnabled}
              rescheduleUrl={rescheduleUrl}
            />
          )}
        </Wrapper>
      </Bonsai>
    );
  }
}

const Wrapper = styled.div`
  margin: 65px 170px;

  @media only screen and (max-width: 480px) {
    margin: 65px 24px;
  }
`;

const SubmitSpinner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;
